import {
  ComboboxMultipleProps,
  ComboboxProps,
  ComboboxSelectProps,
  SelectMultipleProps,
} from "../ComboboxTypes";

export const ADD_NEW = Symbol.for("add-new");
export const SELECT_ALL = Symbol.for("select-all");

/**
 * Default function to convert an item to a string representation
 * @template Item - The type of the item
 * @param item - The item to convert to string
 * @returns String representation of the item or empty string if null/undefined
 */
export const defaultItemToString = function <Item>(item: Item | null) {
  return item != null ? String(item) : "";
};

/**
 * Default function to generate a unique key for an item
 * @template Item - The type of the item
 * @param item - The item to generate a key for
 * @returns The item itself as the key
 */
export const defaultItemToKey = function <Item>(item: Item | null) {
  return item;
};

export function isMultiple<Item>(
  props: ComboboxProps<Item> | ComboboxSelectProps<Item>,
): props is ComboboxMultipleProps<Item> | SelectMultipleProps<Item> {
  return Object.hasOwn(props, "multiple") && props.multiple === true;
}

export function getScrollParent(node: HTMLElement | null) {
  if (node == null) {
    return null;
  }

  if (node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    if (node.parentNode instanceof HTMLElement) {
      return getScrollParent(node.parentNode);
    }
    return null;
  }
}
